import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy-content">
        <h1>Privacy Policy for Chamcha (چمچة)</h1>
        <p className="last-updated">Last Updated: February 24, 2026</p>

        <p>Noon Solutions ("we", "our", or "us") operates the Chamcha (چمچة) mobile application (the "Service"). This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data.</p>

        <h2>1. Information Collection and Use</h2>
        <p>We collect several different types of information for various purposes to provide and improve our Service to you.</p>
        
        <h3>Types of Data Collected:</h3>
        <ul>
            <li><strong>Personal Data:</strong> While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you (e.g., Email address, Full name, User profile data).</li>
            <li><strong>Usage Data:</strong> We may collect information on how the Service is accessed and used to improve app functionality.</li>
        </ul>

        <h2>2. Device Permissions and Access</h2>
        <p>To provide specific features within Chamcha, our application requests access to the following native device capabilities:</p>
        <ul>
            <li><strong>Camera (Required):</strong> We request camera access to allow you to take photos of your recipes and cooking creations directly within the app and upload them to your profile.</li>
            <li><strong>Photo Library / Storage:</strong> We request access to your device's photo library so you can select and upload existing images for your recipes and user profile avatar.</li>
            <li><strong>Microphone (Optional):</strong> We may request microphone access if you choose to record video or audio notes alongside your recipe submissions.</li>
            <li><strong>Internet Access:</strong> Required to sync your recipes, profiles, and meal plans with our secure cloud database.</li>
        </ul>
        <p><em>Note: You can revoke these permissions at any time through your device's native OS Settings menu. However, disabling these permissions will restrict your ability to upload recipe images.</em></p>

        <h2>3. Use of Data</h2>
        <p>Noon Solutions uses the collected data for various purposes:</p>
        <ul>
            <li>To provide and maintain the Service</li>
            <li>To allow you to participate in interactive features of our Service (like sharing recipes)</li>
            <li>To provide customer care and support</li>
            <li>To monitor the usage of the Service</li>
            <li>To detect, prevent and address technical issues</li>
        </ul>

        <h2>4. Data Storage and Security</h2>
        <p>The security of your data is important to us. Your data, including recipe images and user profiles, is stored securely on our servers using modern encryption protocols (HTTPS/TLS). While we strive to use commercially acceptable means to protect your Personal Data, no method of transmission over the Internet or method of electronic storage is 100% secure.</p>

        <h2>5. Sharing of Data</h2>
        <p>We do not sell, trade, or rent your personal identification information to others. Any recipes you choose to publish publicly on Chamcha will be visible to other users of the application according to your sharing preferences.</p>

        <h2>6. Changes to This Privacy Policy</h2>
        <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes.</p>

        <h2>7. Contact Us</h2>
        <p>If you have any questions about this Privacy Policy, or if you would like to request the deletion of your account and associated data, please contact us:</p>
        <ul>
            <li>By email: <a href="mailto:muntajabalani98@gmail.com" className="contact-email">muntajabalani98@gmail.com</a></li>
        </ul>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
